import { useTranslation } from "react-i18next";
import { FrontendUserInfo, OrganizationInfo } from "node-library/dist/portal";

import { UserType } from "node-library/dist/constants";
import { DeleteIcon } from "../../../common-components/svgIcons";
import { roleMeetsRequirement } from "node-library/dist/helpers/request_helper";

interface Props {
	organization: OrganizationInfo;
	user: FrontendUserInfo | undefined;
	goToViewOrganizationDetails: () => void;
	deleteOrganization: () => void;
}

export default function OrganizationRow(props: Props) {
	const { t: translation } = useTranslation();

	const {
		organization,
		goToViewOrganizationDetails,
		user,
		deleteOrganization,
	} = props;

	const organizationRowItem: React.ReactNode = (
		<div
			key={organization.organizationId}
			className="organization-list-view-row organization-list-view-item-row typography-body-01"
			onClick={() => {
				goToViewOrganizationDetails();
			}}
		>
			<div className="organization-list-view-row-item">
				{organization.clientCompanyName}
			</div>
			<div className="organization-list-view-row-item">
				{`${organization.city}, ${organization.province}`}
			</div>
			<div className="organization-list-view-row-item">
				{organization.country}
			</div>
			<div className="organization-list-view-row-item organization-list-view-user-count-row-item">
				{organization.usersCount}
			</div>
			<div className="organization-list-view-row-item">
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						gap: "5px",
						marginRight: "40%",
					}}
				>
					{roleMeetsRequirement(user?.role as UserType, UserType.ADMIN) && (
						<div
							id={`delete-organization=${organization.organizationId}`}
							style={{ cursor: "pointer", display: "flex" }}
							onClick={(e) => {
								e.stopPropagation();
								deleteOrganization();
							}}
						>
							<DeleteIcon></DeleteIcon>
						</div>
					)}
				</div>
			</div>
		</div>
	);

	return organizationRowItem;
}
